var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.loading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("h1", { staticClass: "title" }, [_vm._v(" Roles ")]),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "a",
                {
                  staticClass: "button is-link is-outlined",
                  on: {
                    click: function ($event) {
                      return _vm.addRole()
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "plus" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add ")]),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "b-table",
            {
              attrs: {
                loading: _vm.loading,
                narrowed: true,
                striped: true,
                paginated: true,
                data: _vm.roles,
              },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function (props) {
                    return [
                      !!props.column.meta
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                active: !!props.column.meta,
                                label: props.column.meta,
                                dashed: "",
                              },
                            },
                            [[_vm._v(_vm._s(props.column.label))]],
                            2
                          )
                        : _c("span", [_vm._v(_vm._s(props.column.label))]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("b-table-column", {
                attrs: { field: "name", label: "Name", sortable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [[_vm._v(_vm._s(props.row.name))]]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { label: "Actions" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", { staticClass: "field is-grouped" }, [
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-small is-info is-outlined",
                                on: {
                                  click: function ($event) {
                                    return _vm.showEditForm(props.row)
                                  },
                                },
                              },
                              [[_vm._v("Edit")]],
                              2
                            ),
                          ]),
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-small is-danger is-outlined",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteRole(props.row.id)
                                  },
                                },
                              },
                              [[_vm._v("Delete")]],
                              2
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("template", { slot: "empty" }, [_c("nothing-here")], 1),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditing,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditing = $event
            },
            submitCreate: _vm.submitUpdateRole,
          },
        },
        [
          _c("RoleForm", {
            attrs: {
              role: _vm.roleToEdit,
              rights: _vm.rights,
              "is-submitting": _vm.isSubmitting,
            },
            on: {
              submitUpdate: _vm.submitUpdateRole,
              submitCreate: _vm.submitCreateRole,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }